import * as Sentry from '@sentry/react'

function getUserId(): string | null | undefined {
  try {
    return JSON.parse(window.localStorage.getItem('auth') || '').userId
  } catch (e) {
    return null
  }
}

Sentry.init({
  environment: import.meta.env.VITE_SENTRY_ENV,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    new Sentry.Replay({
      // Additional SDK configuration goes in here, for example:
      // maskAllText: true,
      blockAllMedia: true,
    }),
    new Sentry.BrowserTracing(),
  ],
  initialScope: scope => {
    const id = getUserId()
    scope.setUser(id ? { id } : null)
    return scope
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
})
